import { render, staticRenderFns } from "./PageCheckpoints.vue?vue&type=template&id=40c63716&"
import script from "./PageCheckpoints.vue?vue&type=script&lang=ts&"
export * from "./PageCheckpoints.vue?vue&type=script&lang=ts&"
import style0 from "./PageCheckpoints.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports